var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _circle, _circle2, _rect6, _rect7, _circle3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 100,
    width: 400,
    height: 300,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E6E9F4",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 120,
    width: 360,
    height: 160,
    rx: 4,
    fill: "#F8F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 200 L680 200",
    stroke: "#E6E9F4",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340 160 L400 140 L460 180 L520 150 L580 170 L640 130",
    stroke: "#0059b3",
    strokeWidth: 2,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 300,
    width: 110,
    height: 80,
    rx: 4,
    fill: "#F1F4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 300,
    width: 110,
    height: 80,
    rx: 4,
    fill: "#F1F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 300,
    width: 110,
    height: 80,
    rx: 4,
    fill: "#F1F4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 40,
    fill: "#0059b3",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 400,
    r: 30,
    fill: "#0059b3",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 300,
    width: 60,
    height: 60,
    rx: 8,
    fill: "#0059b3",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 50,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#0059b3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 450,
    r: 15,
    fill: "#0059b3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M720 250 L740 270 L720 290",
    stroke: "#0059b3",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.5df3242ee5c3b5872dd7cbc5b312f7fa.svg";
export { ForwardRef as ReactComponent };